module.exports = __webpack_public_path__ + "img/seq3.9ede35e5.png";